var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgColombia = function SvgColombia(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 3.805 3.805 0 8.5 0S17 3.805 17 8.5l-8.5.738Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffda44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.137 12.75a8.502 8.502 0 0 0 14.726 0L8.5 12.195Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#d80027",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.863 12.75A8.47 8.47 0 0 0 17 8.5H0c0 1.547.414 3 1.137 4.25Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0052b4",
      fillOpacity: 1
    }
  }));
};
export { SvgColombia as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTcgMTciIHZlcnNpb249IjEuMSI+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMTAwJSw4NS40OTAxOTYlLDI2LjY2NjY2NyUpO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAwIDguNSBDIDAgMy44MDQ2ODggMy44MDQ2ODggMCA4LjUgMCBDIDEzLjE5NTMxMiAwIDE3IDMuODA0Njg4IDE3IDguNSBMIDguNSA5LjIzODI4MSBaIE0gMCA4LjUgIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoODQuNzA1ODgyJSwwJSwxNS4yOTQxMTglKTtmaWxsLW9wYWNpdHk6MTsiIGQ9Ik0gMS4xMzY3MTkgMTIuNzUgQyAyLjYwNTQ2OSAxNS4yODkwNjIgNS4zNTU0NjkgMTcgOC41IDE3IEMgMTEuNjQ0NTMxIDE3IDE0LjM5NDUzMSAxNS4yODkwNjIgMTUuODYzMjgxIDEyLjc1IEwgOC41IDEyLjE5NTMxMiBaIE0gMS4xMzY3MTkgMTIuNzUgIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMCUsMzIuMTU2ODYzJSw3MC41ODgyMzUlKTtmaWxsLW9wYWNpdHk6MTsiIGQ9Ik0gMTUuODYzMjgxIDEyLjc1IEMgMTYuNTg1OTM4IDExLjUgMTcgMTAuMDQ2ODc1IDE3IDguNSBMIDAgOC41IEMgMCAxMC4wNDY4NzUgMC40MTQwNjIgMTEuNSAxLjEzNjcxOSAxMi43NSBaIE0gMTUuODYzMjgxIDEyLjc1ICIvPgo8L3N2Zz4K";